module.exports = __webpack_public_path__ + "img/kuangjiao_xc2.3cb90338.jpg";